import React from 'react';
import { Typography } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import {
  CreateButtonContent,
  CreateEntityRoutes
} from '../../constants/entity-values';
import OutlinedButton from '../../../../components/buttons/OutlinedButton';
import { Toolbar, ToolbarLeft, ToolbarRight, ToolbarTitle } from './styles';

const ToolBar = ({ tab }) => {
  const history = useHistory();
  const [t] = useTranslation();

  const handleCreateEntity = () => {
    history.push(CreateEntityRoutes[tab]);
  };

  return (
    <Toolbar>
      <ToolbarLeft>
        <ToolbarTitle variant="h2">
          {t('Accommodations & Activities')}
        </ToolbarTitle>
      </ToolbarLeft>

      <ToolbarRight>
        <OutlinedButton onClick={handleCreateEntity}>
          {t(CreateButtonContent[tab])}
        </OutlinedButton>
      </ToolbarRight>
    </Toolbar>
  );
};

export default ToolBar;
